package com.milta.core.localization.translations.bg

import com.milta.core.localization.RouteStrings
import com.milta.core.localization.RouteStringsCoreImpl
import com.milta.core.localization.RouteStringsExtraImpl

internal val Route = RouteStrings(
    core = RouteStringsCoreImpl(
    manualDeliveryTitle = "Нова доставка",
    manualDeliverySubtitle = "Добавете доставка към маршрута",
    recipientNameLabel = "Име на получателя",
    addressLabel = "Адрес",
    phoneNumberLabel = "Телефон",
    deliveryTimeLimitLabel = "Краен час",
    optionalSuffix = "(по избор)",
    submitButton = "Добави доставка",
    saveEditedDeliveryButton = "Запази промяната",
    deliveryCreated = "Доставката е добавена",
    errorRecipientNameRequired = "Името на получателя е задължително",
    errorRecipientNameTooLong = "Името е твърде дълго (макс. 150 знака)",
    errorAddressRequired = "Адресът е задължителен",
    errorAddressTooLong = "Адресът е твърде дълъг (макс. 255 знака)",
    errorPhoneTooLong = "Телефонът е твърде дълъг (макс. 20 знака)",
    errorDuplicateDelivery = "Тази доставка вече е в списъка (същия получател и адрес)",
    errorRouteNotFound = "Маршрутът не е намерен",
    errorForbidden = "Нямате право да редактирате този маршрут",
    errorValidation = "Моля, проверете въведените полета",
    errorGeneric = "Възникна грешка. Опитайте отново.",
    errorRouteNotInProgress = "Този маршрут вече не е в ход. Не може да се добави доставка.",
    unknownRecipientLabel = "Неизвестен",
    driverHomeTitle = "Моят маршрут",
    driverModeBadge = "Режим шофьор",
    routeStatusScheduled = "Планиран",
    routeStatusInProgress = "В ход",
    routeStatusCompleted = "Завършен",
    stopsCountLabel = "спирки",
    startRouteButton = "Стартирай маршрута",
    noRouteTitle = "Няма маршрут",
    noRouteSubtitle = "В момента нямате назначен маршрут.",
    noRoutePastSubtitle = "Нямате назначен маршрут за тази дата.",
    routeInProgressTitle = "Маршрут в ход",
    routeCompletedTitle = "Маршрутът е завършен",
    deliveriesSectionTitle = "Доставки",
    addStopButton = "Добавяне на спирка",
    errorConflict = "Маршрутът вече е стартиран или завършен.",
    greetingPrefix = "Здравей",
    routeOfTheDayLabel = "ДНЕШЕН МАРШРУТ",
    noOtherRouteLabel = "Няма друг планиран маршрут",
    routeLabel = "Маршрут",
    importMenuTitle = "Импортиране на доставки",
    importMenuSubtitle = "Няколко комбинируеми режима — изберете източник",
    importModePhotoPaperTitle = "Снимка — хартиен списък",
    importModePhotoPaperDesc = "Снимайте ръкописен или отпечатан лист",
    importModePhotoLabelTitle = "Снимка — етикет на колет",
    importModePhotoLabelDesc = "Сканирайте етикета, залепен на колет",
    importModePdfTitle = "Импортиране на PDF",
    importModePdfDesc = "Товарителници, сканиран файл",
    importModeExcelTitle = "Excel / CSV",
    importModeExcelDesc = "Ваш собствен формат — колоните се откриват автоматично",
    importModeManualTitle = "Ръчно въвеждане",
    importModeManualDesc = "Име, адрес, телефон, краен срок",
    createRouteTitle = "Създаване на маршрут",
    createRouteEmptyDrivers = "Все още няма шофьори в екипа ви",
    editDeliveriesAction = "Редактиране",
    moreDeliveriesLabel = "още",
    addDeliveriesAction = "Добавяне на доставки",
    assignToTitle = "Възложи на",
    optimizeRouteButton = "Оптимизирай маршрута",
    createRouteButtonNoOptimize = "Създай маршрута",
    errorNoEnterprise = "Няма компания, свързана с акаунта ви",
    errorDriverNotFound = "Шофьорът не е намерен",
    errorNoDeliveries = "Добавете поне една доставка преди да оптимизирате маршрута",
    errorOptimizationUnavailable = "Услугата за оптимизация временно не е достъпна.",
    errorGeocodingFailed = "Някои адреси за доставка не можаха да бъдат намерени. Редактирайте адреса и опитайте отново.",
    dispatchTitle = "Оптимизация",
    optimizedSuccessTitle = "Маршрутът е оптимизиран!",
    optimizedSuccessSubtitleSuffix = "спирки, подредени за най-кратък маршрут",
    stopsStatLabel = "Спирки",
    driverAvailableStatus = "Наличен",
    sendRouteButtonPrefix = "Изпрати маршрута на",
    errorRouteAlreadyDispatched = "Маршрутът вече е изпратен.",
    stopDetailTitlePrefix = "Спирка",
    stopStatusCurrentLabel = "В ход",
    stopStatusUpcomingLabel = "Предстояща",
    stopStatusDeliveredLabel = "Доставена",
    stopStatusFailedLabel = "Неуспешна",
    stopRecipientLabel = "Получател",
    callActionLabel = "Обади се",
    noPhoneLabel = "Няма посочен телефон",
    packagesCountLabel = "колети",
    navigateButton = "Навигация",
    deadlineBeforePrefix = "Преди",
    deadlinePastSuffix = "просрочен",
    validateStopAction = "Потвърди тази спирка",
    teamDashboardTitle = "Маршрути",
    todayDateLabel = "Днес",
    liveBadgeLabel = "На живо",
    statRoutesLabel = "Маршрути",
    statDeliveriesLabel = "Доставки",
    statCompletedLabel = "Завършени",
    teamSectionTitle = "Екип",
    routeStartedAtPrefix = "Стартиран в",
    routeCompletedAtPrefix = "Завършен в",
    routeNotStartedLabel = "Не е стартиран",
    emptyTeamRoutesTitle = "Няма маршрут за този ден",
    emptyTeamRoutesSubtitle = "Никой шофьор от екипа няма планиран маршрут за тази дата.",
    errorInvalidDate = "Невалидна дата",
    routeDetailTitle = "Детайли за маршрута",
    driverEyebrowLabel = "Шофьор",
    failedDeliveryTag = "Неуспешна доставка",
    driverLoadingCheckTitle = "Проверка на товаренето",
    loadingCheckInstructionText = "Проверете дали всички очаквани колети са натоварени в превозното средство, преди да потеглите.",
    expectedPackagesLabel = "колета, очаквани за този маршрут",
    confirmLoadCheckboxPrefix = "Натоварих",
    confirmLoadCheckboxSuffix = "колета, очаквани за този маршрут",
    reportDiscrepancyToggleLabel = "Съобщи за разминаване",
    discrepancyNotePlaceholder = "Напр.: натоварих 9 колета вместо 11…",
    discrepancyNoteTooLong = "Бележката е твърде дълга — максимум 500 знака.",
    undeliveredStopsSectionTitle = "Непоети колети — премахнете от маршрута",
    removedStopNoticePrefix = "„",
    removedStopNoticeMiddle = "“ премахнат от маршрута — 1 спирка по-малко",
    remainingStopsSuffix = "оставащи",
    confirmAndStartButton = "Потвърди и стартирай маршрута",
    loadingOnBehalfOfLabel = "От името на",
    loadingExpectedLabel = "Планиран товар",
    loadingQuestionTitle = "Заредихте ли всички пратки?",
    loadingAllLoadedPrefix = "Да, всички",
    loadingAllLoadedSuffix = "пратки са на борда",
    loadingIncompleteOption = "Непълно зареждане",
    loadingIncompleteHint = "Премахвам засегнатите спирки или обосновавам",
    loadingIncompleteRemoveLabel = "И/или премахнете незаредените спирки",
    slideToStartLabel = "Плъзнете, за да започнете",
    completeRouteButton = "Приключи маршрута",
    completeRouteDialogTitle = "Да приключим ли маршрута?",
    completeRouteDialogPendingCountSuffix = "доставки все още не са обработени",
    completeRouteDialogPendingNote = "Те ще бъдат маркирани като необработени.",
    completeRouteDialogBody = "Това действие е окончателно: маршрутът ще премине в статус „Завършен“ и повече не може да бъде променян.",
    completeRouteDialogBodyAllTreated = "Всички доставки са обработени. Маршрутът ще премине в статус „Завършен“ и повече не може да бъде променян.",
    completeRouteDialogConfirm = "Приключи",
    routeCompletedMessage = "Маршрутът е приключен.",
    stopStatusUntreatedLabel = "Необработена",
    errorCompleteRouteStatusConflict = "Този маршрут не може да бъде приключен в текущото си състояние.",
    errorCompleteRoutePendingStopsConflict = "Все още има доставки в очакване. Потвърдете, за да приключите въпреки това.",
    ),
    extra = RouteStringsExtraImpl(
    packageCountFieldLabel = "Брой колети",
    newStopBadgeLabel = "НОВО",
    reoptimizeResultTitle = "Нов маршрут",
    reoptimizeSuccessTitle = "Маршрутът е реоптимизиран",
    reoptimizeSuccessSubtitleSuffix = "спирка добавена и преместена за най-кратък маршрут.",
    reoptimizeFallbackTitle = "Спирка добавена, реоптимизацията не е налична",
    reoptimizeFallbackSubtitle = "Услугата за оптимизация временно не е достъпна. Новата спирка беше добавена в края на списъка.",
    addedStatLabel = "Добавено",
    backToRouteButton = "Обратно към маршрута",
    routeBatchMultiDriverLink = "Разпредели между няколко шофьори",
    routeBatchSelectTitle = "Разпредели курса",
    routeBatchDeliveriesReadyLabel = "доставки, готови за разпределяне",
    routeBatchDriversSectionTitle = "Шофьори",
    routeBatchDriversSelectedSuffix = "избрани шофьори",
    routeBatchOptimizeToggleTitle = "Оптимизирай маршрута",
    routeBatchOptimizeToggleHelp = "RoutaR разпределя и подрежда спирките според разстоянието. Изключено: просто равно разпределение по брой спирки, без изчисляване на маршрут.",
    routeBatchSubmitButtonPrefix = "Разпредели между",
    routeBatchDriversWord = "шофьори",
    routeBatchOptimizationUnavailable = "Услугата за оптимизация временно е недостъпна. Курсът не беше създаден — проверете връзката си и опитайте отново, или изключете „Оптимизирай маршрута“ за незабавно просто разпределение.",
    routeBatchPreviewTitle = "Преглед на разпределението",
    routeBatchPreviewEyebrowMiddle = "доставки, разпределени между",
    routeBatchPreviewEyebrowSuffix = "шофьори",
    routeBatchStopsChipSuffix = "спирки",
    routeBatchDistanceLabel = "Разстояние",
    routeBatchDurationLabel = "Очаквана продължителност",
    routeBatchDistanceNotCalculated = "Неизчислено",
    routeBatchOptimizeDisabledBanner = "Оптимизацията е изключена: равно разпределение по брой спирки, без изчисляване на разстояние или ред.",
    routeBatchReoptimizeButton = "Преоптимизирай",
    routeBatchDispatchButton = "Потвърди и изпрати",
    errorRouteBatchAlreadyDispatched = "Тази група курсове вече е изпратена на шофьорите — не може повече да бъде променяна.",
    routeBatchDispatchedTitle = "Курсовете са изпратени!",
    routeBatchDispatchedSubtitleSuffix = "шофьори уведомени едновременно, всеки със своя планиран курс.",
    routeBatchStatRoutesLabel = "Курсове",
    routeBatchStatDeliveriesLabel = "Доставки",
    routeBatchStatusLabel = "Статус",
    routeBatchStatusDispatchedValue = "Изпратена",
    routeBatchSentAtLabel = "Изпратено на",
    routeBatchPerDriverTitle = "Детайли по шофьор",
    routeBatchDriverScheduledStatus = "Планирана",
    routeBatchBackToHomeButton = "Обратно към началния екран",
    errorTooManyDrivers = "Не можете да изберете повече от 50 шофьори наведнъж.",
    errorTooManyDeliveries = "Партида не може да съдържа повече от 500 доставки.",
    createRouteFabLabel = "Нов курс",
    createOwnRouteButtonLabel = "Създай / оптимизирай моя курс",
    createOwnRouteTitle = "Създай моя курс",
    createOwnRouteDeliveriesCountSuffix = "доставки готови",
    stopStatusEnRouteLabel = "По път",
    yesterdayDateLabel = "Вчера",
    periodPastLabel = "Минало",
    periodTomorrowLabel = "Утре",
    viewRouteButton = "Виж маршрута",
    viewButton = "Виж",
    noRouteTomorrowTitle = "Нищо планирано за утре",
    noRouteTomorrowSubtitle = "Планирайте маршрут предварително, за да е готов още утре сутрин.",
    planRouteButtonLabel = "Планирай маршрут",
    myRoutesTodayTitle = "Вашите маршрути днес",
    myRoutesTitle = "Вашите маршрути",
    weekdayShortNames = listOf("Пон", "Вт", "Ср", "Чет", "Пет", "Съб", "Нед"),
    weekdayFullNames = listOf("Понеделник", "Вторник", "Сряда", "Четвъртък", "Петък", "Събота", "Неделя"),
    monthNames = listOf("януари", "февруари", "март", "април", "май", "юни", "юли", "август", "септември", "октомври", "ноември", "декември"),
    statRoutesTodayLabel = "Маршрути днес",
    statStopsTodayLabel = "Спирки днес",
    statOnTimeLabel = "Навреме днес",
    statAvgProgressLabel = "Среден напредък",
    inProgressSectionTitle = "В процес",
    upcomingSectionTitle = "Предстоящи",
    doneSectionTitle = "Завършени",
    seeAllLabel = "Виж всички",
    continueRouteButton = "Продължи маршрута",
    detailsLinkLabel = "Детайли",
    deliveryProofTitle = "Потвърждаване на доставката",
    deliveryProofStatusSectionLabel = "Статус на доставката",
    deliveryProofPhotoSectionLabel = "Снимка доказателство",
    deliveryProofPhotoHint = "Задължително за потвърждаване",
    deliveryProofTakePhotoCta = "Направете снимка",
    deliveryProofRetakePhotoCta = "Направете нова снимка",
    deliveryProofRetakeChipLabel = "Отново",
    deliveryProofCommentSectionLabel = "Коментар",
    deliveryProofCommentRequiredSuffix = "задължителен при неуспех",
    deliveryProofCommentPlaceholderOptional = "По желание — подробности за доставката…",
    deliveryProofCommentPlaceholderRequired = "Обяснете причината за неуспеха…",
    deliveryProofCommentRequiredError = "Коментар е задължителен при неуспешна доставка",
    deliveryProofSubmitButton = "Потвърждаване на доставката",
    deliveryProofErrorInvalidPhoto = "Снимката е нечетима или форматът не се поддържа. Направете нова снимка и опитайте отново.",
    deliveryProofAlreadyProcessedBanner = "Тази спирка вече е обработена и не може да бъде променяна.",
    deliveryConfirmTitle = "Доставката е потвърдена",
    deliveryConfirmSuccessTitle = "Доставката е потвърдена",
    deliveryConfirmSuccessSubtitle = "Доказателството беше запазено за тази спирка.",
    deliveryConfirmFailedTitle = "Неуспехът е регистриран",
    deliveryConfirmFailedSubtitle = "Коментарът и снимката бяха изпратени на мениджъра.",
    deliveryConfirmRouteCompletedTitle = "Маршрутът е завършен!",
    deliveryConfirmRouteCompletedSubtitle = "Всички спирки бяха обработени.",
    deliveryConfirmValidatedAtLabel = "Потвърдено на",
    deliveryConfirmNextStopEyebrowPrefix = "Следваща спирка",
    deliveryConfirmGoToNextStopButton = "Към следващата спирка",
    deliveryConfirmAllDoneMessage = "Това беше последната спирка от маршрута — не забравяйте да го приключите.",
    offlineBannerTitle = "Без връзка",
    offlineBannerRouteSubtitle = "потвържденията ви ще бъдат изпратени веднага щом връзката се възстанови",
    offlineBannerValidateSubtitle = "ще бъде запазено локално",
    offlineSyncingBannerTitle = "Синхронизация в ход",
    offlineSyncingSubtitleSuffix = "доставки изпратени",
    offlineRetryBannerTitle = "Синхронизацията неуспешна",
    offlineRetryBannerSubtitle = "нов опит при следващата връзка с мрежата",
    offlineSyncSuccessToastSuffix = "доставки синхронизирани успешно",
    offlineQueuedBadgePendingLabel = "Изчаква изпращане",
    offlineQueuedBadgeSyncingLabel = "Изпраща се",
    offlineQueuedBadgeFailedLabel = "Неуспешно — предстои нов опит",
    offlineQueuedBadgeConflictLabel = "Вече обработено другаде",
    offlineDismissConflictAction = "Премахни",
    offlineValidatedLocallyAtPrefix = "потвърдено локално в",
    offlineAddStopRequiresConnectionSuffix = "(изисква връзка)",
    deliveryProofOfflineSubmitButton = "Запази (отложена синхронизация)",
    deliveryProofSavedLocallyTitle = "Запазено локално",
    deliveryProofSavedLocallySubtitle = "Тази доставка ще бъде изпратена автоматично веднага щом връзката бъде възстановена.",
    routeScheduledBannerTitle = "Маршрутът още не е стартиран",
    routeScheduledBannerSubtitle = "Стартирайте маршрута, за да можете да потвърдите доставка.",
    geocodeIssueTag = "Адресът не е локализиран",
    regeocodeAction = "Опитай отново геолокацията",
    regeocodeSuccessMessage = "Адресите са актуализирани",
    dashboardTitle = "Dashboard",
    viewAllAction = "Виж всички",
    deleteRouteDialogTitle = "Да изтрием ли маршрута?",
    deleteRouteDialogMessage = "Този маршрут ще бъде изтрит окончателно. Това действие е необратимо.",
    errorRouteDeleteConflict = "Изтриването не е възможно: маршрутът в момента е в ход.",
    errorDriverHasActiveRoute = "В момента вече има друг маршрут в ход. Завършете го, преди да стартирате този.",
    dashboardLiveBadge = "На живо",
    routeBatchNoStopsTag = "Без спирки",
    routeBatchNoStopsDialogTitle = "Шофьор без спирки",
    routeBatchNoStopsDialogMessage = "Поне един шофьор няма назначена спирка. Той все пак ще получи празен маршрут, ако не бъде премахнат от тази партида. Изпращане въпреки това?",
    ),
)
